"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormulaInfoModal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _Modal = _interopRequireDefault(require("@cimpress/react-components/lib/Modal"));

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

var _IconInformationCircle = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconInformationCircle"));

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FormulaInfoModal = function FormulaInfoModal(props) {
  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      updateShowModal = _useState2[1];

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, null,
    /*#__PURE__*/
    _react["default"].createElement("div", _extends({
      className: "clickable",
      onClick: function onClick() {
        return updateShowModal(true);
      }
    }, props),
    /*#__PURE__*/
    _react["default"].createElement(_IconInformationCircle["default"], null)),
    /*#__PURE__*/
    _react["default"].createElement(_Modal["default"], {
      bsStyle: "info",
      show: showModal,
      onRequestHide: function onRequestHide() {
        return updateShowModal(false);
      },
      title: formatMessage(_messages["default"].formulaInstructionsTitle),
      closeButton: true,
      footer:
      /*#__PURE__*/
      _react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return updateShowModal(false);
        }
      }, formatMessage(_messages["default"].closeFormulaInfo))
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactIntl.FormattedMessage, _extends({}, _messages["default"].formulaInstructions, {
      values: {
        p: function p() {
          for (var _len = arguments.length, msg = new Array(_len), _key = 0; _key < _len; _key++) {
            msg[_key] = arguments[_key];
          }

          return (
            /*#__PURE__*/
            _react["default"].createElement("p", null, msg)
          );
        },
        code: function code() {
          for (var _len2 = arguments.length, msg = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            msg[_key2] = arguments[_key2];
          }

          return (
            /*#__PURE__*/
            _react["default"].createElement("code", null, msg)
          );
        },
        b: function b(msg) {
          return (
            /*#__PURE__*/
            _react["default"].createElement("b", null, msg)
          );
        }
      }
    }))))
  );
};

exports.FormulaInfoModal = FormulaInfoModal;